/* eslint-disable import/prefer-default-export */

import {
  GET_DEVICES_LIST,
  GET_SAFEFLOORS_LIST,
  GET_AVAILABLE_PRODUCERS,
  GET_AVAILABLE_DEVICETYPES,
  SET_DEVICES_SORT,
  SET_DEVICES_CONNECT_FILTER,
  SET_DEVICES_PRODUCENT_FILTER,
  SET_DEVICES_SEARCH_QUERY,
  SET_DEVICES_DEVICETYPE_FILTER,
  RESET_DEVICES_PAGING,
  RESET_DEVICES,
} from '../constants';
import { insertParams } from '../core/actionHelpers';
import http from '../core/HttpClient';
import urls from '../constants/urls';

export function getAvailableProducers() {
  return {
    type: GET_AVAILABLE_PRODUCERS,
    promise: http.get(`${urls.API_LISTS}/producers`),
  };
}

export function getAvailableDeviceTypes() {
  return {
    type: GET_AVAILABLE_DEVICETYPES,
    promise: http.get(`${urls.API_LISTS}/devicetypes`),
  };
}


export function getDevicesList(params) {
  const url = insertParams(`${urls.API2_URL}`, params);
  return {
    type: GET_DEVICES_LIST,
    promise: http.get(url),
  };
}

export function getSafeFloorList(params){
  const url = insertParams(`${urls.API2_URL}`, params);
  return {
    type: GET_SAFEFLOORS_LIST,
    promise: http.get(url),
  };
}
export function setSort(sort) {
  return {
    type: SET_DEVICES_SORT,
    sort,
  };
}

export function setConnectFilter(filter) {
  return {
    type: SET_DEVICES_CONNECT_FILTER,
    filter,
  };
}

export function setProducentFilter(filter) {
  return {
    type: SET_DEVICES_PRODUCENT_FILTER,
    filter,
  };
}

export function setDeviceTypeFilter(filter) {
  return {
    type: SET_DEVICES_DEVICETYPE_FILTER,
    filter,
  };
}

export function setSearchQuery(searchQuery) {
  return {
    type: SET_DEVICES_SEARCH_QUERY,
    searchQuery,
  };
}

export function resetPaging() {
  return {
    type: RESET_DEVICES_PAGING,
  };
}

export function resetDevices() {
  return {
    type: RESET_DEVICES,
  };
}



// WEBPACK FOOTER //
// ./src/actions/home.js